import React__default from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useIntl, useSelector, statusSuccess } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../Context/RxGlassesConfiguratorContext.js';
import { ProductSelectionStep } from '../components/ProductSelectionStep/ProductSelectionStep.js';
import { getSelectedVariantParentSku } from '../utils/get-selected-variant-parent-sku.js';
import { getSelectedFrame, getAddOns, getSelectedAddOn, getAreAddOnsOptional } from '../../../state/configurator/selectors.js';
import { resetSelectedAddOn, selectAddOn } from '../../../state/configurations/actions.js';

const LensAddOnStepContainer = ()=>{
    const dispatch = useDispatch();
    const { getLabel , currency  } = useIntl();
    const { goToNextStep  } = useConfiguratorContext();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    var ref;
    const { readMoreLink  } = (ref = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.addOnsStep) !== null && ref !== void 0 ? ref : {};
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const areAddOnsOptional = useSelector(getAreAddOnsOptional);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        if (sku === '') {
            //Reset the Add On selection if "No Add On" option is selected
            dispatch(resetSelectedAddOn({
                frameSku: frame.sku,
                reason: 'user selection'
            }));
        } else {
            dispatch(selectAddOn({
                frameSku: frame.sku,
                addOnSku: sku,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const noAddOnOption = {
        variants: [],
        isDefault: false,
        sku: '',
        title: getLabel('products.glasses.lensAddOn.noAddOn.title'),
        description: getLabel('products.glasses.lensAddOn.noAddOn.description'),
        price: {
            originalPrice: 0,
            currency
        }
    };
    let selectedAddOnParentSku = '';
    const addOnsList = areAddOnsOptional ? [
        ...addOns.result,
        noAddOnOption
    ] : addOns.result;
    if (selectedAddOn) {
        selectedAddOnParentSku = getSelectedVariantParentSku(addOnsList, selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku) || (selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: addOnsList,
        selectedItemSku: selectedAddOnParentSku,
        readMoreLink: readMoreLink
    });
};

export { LensAddOnStepContainer };
//# sourceMappingURL=LensAddOnStepContainer.js.map
